// components/SessionTimer.jsx
import React, { useState, useEffect } from 'react';
import { Box, Typography, Tooltip, IconButton } from '@mui/material';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { getTokenRemainingTime, formatRemainingTime, isTokenExpired, clearAuthData } from '../../../services/authService';

/**
 * Componente que muestra un contador del tiempo restante de sesión.
 * Se coloca en el header del Dashboard.
 */
export default function SessionTimer({ onExpired }) {
  const [timeRemaining, setTimeRemaining] = useState(getTokenRemainingTime());
  const [isExpired, setIsExpired] = useState(isTokenExpired());

  useEffect(() => {
    // Actualizar cada segundo
    const interval = setInterval(() => {
      const remaining = getTokenRemainingTime();
      setTimeRemaining(remaining);

      if (remaining <= 0 && !isExpired) {
        setIsExpired(true);
        if (onExpired) onExpired();
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [isExpired, onExpired]);

  if (isExpired || timeRemaining <= 0) {
    return null;
  }

  const formatted = formatRemainingTime(timeRemaining);
  const minutes = Math.floor(timeRemaining / 60000);

  // Color según tiempo restante
  let color = 'text.secondary';
  if (minutes < 5) {
    color = 'error.main';
  } else if (minutes < 15) {
    color = 'warning.main';
  }

  return (
    <Tooltip title={`Sesión expira en ${formatted}`}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 0.5,
          px: 1,
          py: 0.5,
          borderRadius: 1,
          bgcolor: minutes < 5 ? 'rgba(211, 47, 47, 0.1)' : 'rgba(0, 0, 0, 0.04)',
        }}
      >
        <AccessTimeIcon sx={{ fontSize: 16, color }} />
        <Typography
          variant="caption"
          sx={{
            fontWeight: minutes < 5 ? 'bold' : 'normal',
            color,
            fontVariantNumeric: 'tabular-nums',
          }}
        >
          {formatted}
        </Typography>
      </Box>
    </Tooltip>
  );
}
